export const isAllCaps = (value: string): boolean =>
	/[A-Z]/.test(value) && value === value.toUpperCase();
